import { useState, useEffect } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { eiwrsSiteInventoryServices } from "../../../APIServices/EIWRS/eiwrsSiteInventoryServices";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../APIServices/studyEventFormSchemaServices";

const DispenseSubjectKit = ({
  Show,
  Hide,
  Title,
  subjectData,
  randomizationType,
  getStudySiteSubjectRandomizationData,
}) => {
  const [randomizerLoader, setRandomizerLoader] = useState(false);
  const [kitLoader, setKitLoader] = useState(false);
  const [kitList, setKitList] = useState([]);
  const [eventRows, setEventRows] = useState([]);
  const [eventId, setEventId] = useState("");
  const [timepointUniqueId, setTimepointUniqueId] = useState("");
  const [kitId, setKitId] = useState("");
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getAvailableSiteKit = async () => {
    setKitLoader(true)
    let data = await eiwrsSiteInventoryServices.getAvailableSiteKit(studyId, subjectData?.siteId, subjectData?.subjectId, StudyMode)
    setKitList(data?.data || [])
    setKitLoader(false)
  }

  const getEventBasedonSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, subjectData?.schemaId, "all");
    setEventRows(data?.data || []);
  };

  useEffect(() => {
    if (subjectData) {
      getAvailableSiteKit();
    }
  }, [subjectData?.siteId, subjectData?.subjectId]);

  useEffect(() => {
    if (subjectData && randomizationType != "assignBased") {
      getEventBasedonSchema();
    }
  }, [subjectData?.schemaId, randomizationType]);

  const assignStudySubjectRandomizationKit = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Randomization!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Randomized it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setRandomizerLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = subjectData?.siteId
        userData.subjectId = subjectData?.subjectId
        if (randomizationType === "assignBased") {
          userData.eventId = subjectData?.eventId
          if (subjectData?.timepointUniqueId) {
            userData.timepointUniqueId = subjectData?.timepointUniqueId
          }
          if (subjectData?.formId) {
            userData.formId = subjectData?.formId
          }
          if (subjectData?.formVersion) {
            userData.formVersion = subjectData?.formVersion
          }
          if (subjectData?.fieldId) {
            userData.fieldId = subjectData?.fieldId
          }
          if (subjectData?.fieldCode) {
            userData.fieldCode = subjectData?.fieldCode
          }
        } else {
          userData.eventId = eventId
          if (timepointUniqueId) {
            userData.timepointUniqueId = timepointUniqueId
          }
        }
        userData.mode = StudyMode
        userData.kitId = kitId
        let data = await eiwrsRandomizationSchemaServices.assignStudySubjectRandomizationKit(userData)
        if (data?.statusCode === 200) {
          setKitId("")
          setEventId("")
          setTimepointUniqueId("")
          getAvailableSiteKit()
          getStudySiteSubjectRandomizationData()
          Hide()
        }
        setRandomizerLoader(false)
      }
    });
  };
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {kitLoader ? (
          <PageLoader />
        ) :
          <>
            {randomizationType != "assignBased" &&
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Event{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  onChange={(e) => { setEventId(e.target.value); setTimepointUniqueId(e.target[e.target.selectedIndex].id) }}
                  style={{ fontSize: 12 }}
                  disabled={eventRows?.length === 0}
                  className="br3"
                >
                  <option selected={eventId === ""} value="">Select Event</option>
                  {eventRows?.map((item, index) => (
                    <option
                      key={index}
                      selected={
                        `${item.eventId}${item?.row?.["TIMEPOINTUNIQUEID"] || ""
                        }` === `${eventId}${timepointUniqueId || ""}`
                      }
                      value={item?.eventId}
                      id={item?.row?.["TIMEPOINTUNIQUEID"] || ""}
                    >
                      {item?.row?.["EVENTID"]} {item?.row?.["TIMEPOINTUNIQUEID"] && `(${item?.row?.["TIMEPOINTID"]})`}
                    </option>
                  ))}
                  <option selected={eventId === `${subjectData?.subjectId}SpecialForm`} value={`${subjectData?.subjectId}SpecialForm`} id="">Special Form</option>
                </Form.Select>
              </Form.Group>
            }
            <Form.Group className="mb-3">
              <Form.Label className="mb-1 fw-semibold">
                Kit <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                onChange={(e) => setKitId(e.target.value)}
                style={{ fontSize: 12 }}
                className="br3"
                disabled={kitList?.length === 0}
                value={kitId}
              >
                <option value="">Select Kit</option>
                {kitList?.map((kit => (
                  <option value={kit?.kitId}>
                    {`${kit?.kitNumber}${kit?.columns?.filter(
                      (column) => column?.isUnique === "yes"
                    )?.length > 0
                      ? ` (${kit?.columns
                        ?.filter((column) => column?.isUnique === "yes")
                        ?.map(
                          (data) => `${data?.columnName}: ${data?.columnValue}`
                        )
                        ?.join(", ")})`
                      : ""
                      }`}
                  </option>
                )))}
              </Form.Select>
            </Form.Group>
          </>
        }
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          disabled={
            randomizationType === "assignBased" ?
              (!kitId || randomizerLoader)
              :
              (!eventId || !kitId || randomizerLoader)
          }
          className="updateProfile"
          onClick={assignStudySubjectRandomizationKit}
        >
          {randomizerLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Despensing...
            </div>
          ) : (
            "Despense Kit"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default DispenseSubjectKit;
